/* The files a record's Zoho Books source keeps there, each with its link (decision 4805). */
.left {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-top: var(--space-2);
}

.title {
  margin: 0;
  font-weight: var(--font-weight-semibold);
}

.hint {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.file {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding-block: var(--space-1);
  border-bottom: 1px solid var(--border);
}

.name {
  min-width: 0;
  overflow-wrap: anywhere;
}

.link {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  color: var(--navy-primary);
  font-weight: var(--font-weight-semibold);
}
